@if ({ isSmallScreen: isSmallScreen$ | async }; as context) {
  <nav
    class="flex flex-col md:flex-row bg-black py-4 md:justify-between px-4 md:px-24 lg:px-36 xl:px-48 2xl:px-56"
    aria-labelledby="section-navigation"
    [ssDirectus]="{
      collection: 'jumpToSection',
      item: jumpToSection.id,
      fields: ['sectionLink'],
    }"
  >
    <div
      [attr.role]="context.isSmallScreen ? 'button' : null"
      [attr.tabindex]="context.isSmallScreen ? '0' : null"
      [attr.aria-controls]="
        context.isSmallScreen ? 'jump-to-section-menu' : null
      "
      [attr.aria-expanded]="context.isSmallScreen ? expanded : null"
      (click)="context.isSmallScreen && expanded.set(!expanded())"
      (keypress)="
        context.isSmallScreen &&
          $event.key === 'Enter' &&
          expanded.set(!expanded())
      "
      class="flex items-center justify-between"
    >
      <h6 id="section-navigation" class="leading-6">Jump to a section:</h6>
      @if (context.isSmallScreen) {
        <div
          class="h-5 w-5 flex flex-col items-center justify-center rounded-full bg-gradient-to-r from-ss-gold to-[#836231]"
        >
          <svg
            [@rotate]="expanded() ? '1' : '0'"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="white"
            class="w-6 h-6"
            aria-label="down arrow"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.5 8.25l-7.5 7.5-7.5-7.5"
            />
          </svg>
        </div>
      }
    </div>
    <ul
      [ngClass]="
        context.isSmallScreen
          ? 'overflow-hidden flex flex-col gap-6'
          : 'contents'
      "
      id="jump-to-section-menu"
      [@slideUpDown]="context.isSmallScreen ? (expanded() ? '1' : '0') : '1'"
    >
      @if (context.isSmallScreen ? expanded() : false) {
        <div>
          @for (
            item of jumpToSection.sectionLink;
            track sectionTrackByFn($index, item)
          ) {
            <li class="mr-4">
              <a
                [routerLink]="['./']"
                [fragment]="item.sectionId"
                class="text-[14px] font-medium tracking-wider uppercase no-underline"
                >{{ item.text }}</a
              >
            </li>
          }
        </div>
      }
      @if (!context.isSmallScreen) {
        <div class="contents">
          @for (
            item of jumpToSection.sectionLink;
            track sectionTrackByFn($index, item)
          ) {
            <li class="mr-4">
              <a
                [routerLink]="['./']"
                [fragment]="item.sectionId"
                class="text-[14px] font-medium tracking-wider uppercase no-underline"
                >{{ item.text }}</a
              >
            </li>
          }
        </div>
      }
    </ul>
  </nav>
}
